import { Divider, styled } from '@material-ui/core'

export const DividerSpaced = styled(Divider)({
  marginTop: '1em',
  marginBottom: '1em',
})
